import { getSlotImage, Slot, SlotImgDevice } from '@bcraft-frontend-lib/slots'

export type SlotIconViewModel = {
  slot: Slot
  gameName: string
  provider: string
  imageUrl: string
  imageUrlWide?: string
}

export const getCatalogImageUrl = (slot: Slot, device: SlotImgDevice = 'desktop'): string =>
  getSlotImage(slot.id, device)

export const adaptSlotForIcon = (slot: Slot, device: SlotImgDevice = 'desktop'): SlotIconViewModel => ({
  slot,
  gameName: slot.name,
  provider: slot.provider,
  imageUrl: getCatalogImageUrl(slot, device),
})
